import { Button, Classes, Dialog, H1, HTMLTable, Spinner } from "@blueprintjs/core";
import { Icon, Intent } from "@blueprintjs/core";
// import { Users } from '@just-in-types';
import { Timestamp } from "@firebase/firestore-types";
import * as React from "react";
import InputMobile from "../components/InputMobile";
import VehicleModal from "../components/VehicleModal";
import modelList from '../store/data/modelList';
import firebase from "../firebase";
import { firestore } from "../firebase";

import TimestampFunc = firebase.firestore.Timestamp;
import { IStrings, strings } from "../store/reducers/strings";
import "../styles/justin.css";

import { differenceInDays } from "date-fns";
import Notifications from "./Notifications";

const hoverRow = {
  cursor: "hand",
  fontSize: "16px",
};

interface JustInPageState {
  accessDashboardText: string;
  accessDashboardTextSpanish: string;
  addingNewPick: boolean;
  businessDoc: any;
  businessId: string | null;
  descText: string;
  descTextSecondline: string;
  descTextSpanish: string;
  descTextSpanishSecondline: string;
  enableVipClub:boolean;
  englishKeyword:string;
  englishLocation:string;
  englishVipClubCheckboxText:string;
  englishVipClubHoverText:string;
  helpMenu:string;
  helpMenus:string;
  homeButtonText:string;
  homeButtonTextSpanish:string;
  homePageUrl:string;
  howitworksImg:string;
  howitworksText:string;
  howitworksTexts:string;
  isOpenHelp: boolean;
  picks: VehiclePick[];
  logo: null | string;
  language: "eng" | "esp";
  languageStrings: IStrings;
  matches: any;
  matchesNewVehicle: any;
  matchesVehicle: any;
  mobile: string | null;
  retToPageText: string;
  retToPageTextSpanish: string;
  rowSelected: null | number;
  showVehicleModal: boolean;
  site: null | object;
  siteId: string | null;
  spanishKeyword: string;
  spanishLocation: string;
  spanishVipClubCheckboxText: string;
  spanishVipClubHoverText: string;
  tearApartVehicleOgden: boolean;
  tearApartVehicleSlc: boolean;
  titleText: string;
  titleTextSpanish: string;
  tncText: string;
  tncTextSpanish: string;
  vehicle: null | any;
}

interface VehiclePick {
  docId: string;
  businessId: string;
  combined: string;
  firstName: string;
  make: string;
  mobile: string;
  model: string;
  remainDays?: number;
  siteId: string;
  textSent: boolean;
  timestamp?: null | Timestamp;
  userId: string;
  yearMax: number;
  yearMin: number;
  matches?: any;
}

const getMatchesForVehicle = firebase.functions().httpsCallable("getMatchesForVehicle");

class JustInPage extends React.Component<any, any> {
  public state: JustInPageState = {
    accessDashboardText: "Enter your mobile number to access Dashboard",
    accessDashboardTextSpanish: "Ingrese su número de teléfono móvil",
    addingNewPick: false,
    businessDoc: null,
    businessId: null,
    descText: "Get Alerts for newly-added vehicles, ",
    descTextSecondline: "Straight to your phone! We'll send you a text when it arrives.",
    descTextSpanish: "Regístrese para recibir alertas de texto de Fresh Stock en ",
    descTextSpanishSecondline: "Directo a su teléfono! Le enviaremos un mensaje de texto cuando llegue",
    enableVipClub: false,
    englishKeyword: '',
    englishLocation: '',
    englishVipClubCheckboxText: '',
    englishVipClubHoverText: '',
    helpMenu:'If you are returning to this page and want to check the vehicle picks you have already made, then enter your phone number it the bottom box below where it says “Returning to this page? Enter your mobile number to access Dashboard”.<br /><br /> If you haven’t ever entered a vehicle pick, then you will need to pick a Make and Model you want to receive notifications for.  Year range is optional.<br /><br /> Once you are finished entering the vehicle you want to receive notifications for, then enter a valid mobile number.<br /><br /> You can access your Dashboard with the green Next button.  Your Dashboard is where you can edit, renew or delete vehicle picks. ',
    helpMenus:'Si regresa a esta página y desea verificar las selecciones de vehículos que ya realizó, ingrese su número de teléfono en el cuadro inferior donde dice “¿Regresando a esta página? Ingrese su número de teléfono móvil para acceder al Tablero ”.<br /><br />Si nunca ingresó una selección de vehículo, deberá elegir una Marca y Modelo para los que desea recibir notificaciones. El rango de años es opcional.<br /><br />Una vez que haya terminado de ingresar el vehículo para el que desea recibir notificaciones, ingrese un número de teléfono móvil válido.<br /><br />Puede acceder a su Panel de control con el botón verde Siguiente. Su Tablero es donde puede editar, renovar o eliminar selecciones de vehículos.',  
    homeButtonText:'Home',
    homeButtonTextSpanish:'Hogar',
    homePageUrl:'',
    howitworksImg:'',
    howitworksText:'How It Works',
    howitworksTexts:'Cómo Funciona',
    isOpenHelp: false,
    language: "eng",
    languageStrings: strings.eng,
    logo: null,
    matches: null,
    matchesNewVehicle: [],
    matchesVehicle: null,
    mobile: null,
    picks: [],
    retToPageText: "Returning to this page?",
    retToPageTextSpanish: "Ingrese su número de teléfono móvil",
    rowSelected: null,
    showVehicleModal: false,
    site: null,
    siteId: null,
    spanishKeyword: '',
    spanishLocation: '',
    spanishVipClubCheckboxText: '',
    spanishVipClubHoverText: '',
    tearApartVehicleOgden:false,
    tearApartVehicleSlc:false,
    titleText: "Just In vehicle alerts at ",
    // titleText: "Sign up for Fresh Stock text alerts at ",
    titleTextSpanish: "Regístrese para recibir alertas de texto de Fresh Stock en ",
    tncText:
      "By selecting Next, you are signing up to receive automated text alerts and marketing calls from an autodialer system or live person. Consent to receive automated text alerts not required for purchase. Upon completion of this form, you will receive a text message with instructions to confirm your opt-in. Approx 31 msg/mo & Data Rates May Apply. Reply HELP for HELP, STOP ALL to cancel.",
    tncTextSpanish:
      "Al seleccionar Siguiente, se registra para recibir alertas de texto automatizadas y llamadas de marketing de un sistema de marcación automática o una persona en vivo. No se requiere consentimiento para recibir alertas de texto automáticas para la compra. Al completar este formulario, recibirá un mensaje de texto con instrucciones para confirmar su suscripción. Se pueden aplicar hasta 31 msg / mes y tarifas de datos. Responda HELP para HELP, STOP ALL para cancelar.",
    vehicle: null,
  };
  public welcomeInstructions = (
    <tr style={hoverRow}>
      <td />
      <td>{this.state.languageStrings.welcomeInstructions}</td>
      <td>&nbsp;</td>
    </tr>
  );

  public toggleLanguage = () => {
    let { language } = this.state;

    // Strings for English language
    const {
      accessDashboardText,
      accessDashboardTextSpanish,
      descText,
      descTextSecondline,
      descTextSpanish,
      descTextSpanishSecondline,
      helpMenu,
      helpMenus,
      homeButtonText,
      homeButtonTextSpanish,
      howitworksText,
      howitworksTexts,
      retToPageText,
      retToPageTextSpanish,
      titleText,
      titleTextSpanish,
      tncText,
      tncTextSpanish,
    } = this.state;

    strings.eng.signUpWelcome = titleText;
    strings.esp.signUpWelcome = titleTextSpanish;

    strings.eng.getAlertsPromo = descText;
    strings.esp.getAlertsPromo = descTextSpanish;

    strings.eng.getAlertsPromoSecondLine = descTextSecondline;
    strings.esp.getAlertsPromoSecondLine = descTextSpanishSecondline;

    strings.eng.disclaimer = tncText;
    strings.esp.disclaimer = tncTextSpanish;

    strings.eng.enterMobileReturnString = retToPageText;
    strings.esp.enterMobileReturnString = retToPageTextSpanish;

    strings.eng.enterMobileDashboard = accessDashboardText;
    strings.esp.enterMobileDashboard = accessDashboardTextSpanish;

    strings.eng.howitworks = helpMenu;
    strings.esp.howitworks = helpMenus;

    strings.eng.howitworksText = howitworksText;
    strings.esp.howitworksText = howitworksTexts;

    strings.eng.homebtn = homeButtonText;
    strings.esp.homebtn = homeButtonTextSpanish;

    const languageStrings = language === "eng" ? strings.esp : strings.eng;
    language = language === "eng" ? "esp" : "eng";

    this.setState({ language, languageStrings });
  };

  public componentDidMount() {
    const params = this.props.match.params;
    let sitePathFound = null;

    if (params.business && params.business !== "-") {
      firestore
        .collection("businesses")
        .where("path", "==", params.business)
        .get()
        .then( async (snap) => {
          this.setState({
            businessDoc: snap.docs[0].data(),
            businessId: snap.docs[0].id,
            logo: snap.docs[0].data().theme.logo,
          });


          if(!params.site || params.site === "-"){
            await firestore
            .collection("businesses")
            .doc(snap.docs[0].id)
            .collection("sites")
            .where("businessId", "==", snap.docs[0].id)
            .get()
            .then((newSiteSnap) => {
              if(newSiteSnap.size === 1){
                
                sitePathFound = newSiteSnap.docs[0].data().path;
              }              
            });
          }
          
          if ((params.site && params.site !== "-") || sitePathFound !== null) {

            const sPath = sitePathFound !== null ? sitePathFound : params.site;

            firestore
              .collection("businesses")
              .doc(snap.docs[0].id)
              .collection("sites")
              .where("path", "==", sPath)
              // .where("path", "==", params.site)
              .get()
              .then((siteSnap) => {
                if (siteSnap.size > 0) {              

                  const mql = window.matchMedia("only screen and (max-device-width :480px)");
                  // console.log(mql);

                  const siteDoc = siteSnap.docs[0].data();

                  const reqBusinessId = snap.docs[0].id;
                  const reqSiteId = siteDoc.siteId;

                  const tearApartVehicleSlc = (reqSiteId && reqSiteId === '17VBJyeH2crmqQC2OSxx' && reqBusinessId && reqBusinessId === 'gBHr1GdJSlpASgUvkoLW') ? true : false;
                  const tearApartVehicleOgden = (reqSiteId && reqSiteId === '1YYyeZ1YXjGyc6Z6vwRt' && reqBusinessId && reqBusinessId === 'gBHr1GdJSlpASgUvkoLW') ? true : false;

                  this.setState({ tearApartVehicleSlc, tearApartVehicleOgden });

                  const matches = document.querySelector<HTMLElement>(".css-1k7bvv7")!;
                  const mainContainer = document.querySelector<HTMLElement>(".main-container")!;
                  const mainContainer2 = document.querySelector<HTMLElement>(".main-container h2.bp3-heading")!;
                  const bpTextMuted = document.querySelector<HTMLElement>(
                    ".main-container .bp3-label .bp3-text-muted"
                  )!;
                  const newPick = document.querySelector<HTMLElement>(".centerDiv .new-pick")!;

                  let backgroundColor = "#e5e5e5";
                  let fontColor = "#182026";
                  if (siteDoc.jiSignUpUiBackgroundColor) {
                    backgroundColor = siteDoc.jiSignUpUiBackgroundColor;
                    fontColor = siteDoc.jiSignUpUiFontColor;
                  }
                  mainContainer2.style.color = fontColor;
                  matches.style.backgroundColor = backgroundColor;
                  mainContainer.style.color = fontColor;
                  newPick.style.color = fontColor;
                  bpTextMuted.style.color = fontColor;

                  // “Espanol” button Enable Switch
                  const toggleLng = document.querySelector<HTMLElement>(".main-container .toggle_lng")!;
                  if (toggleLng) {
                    if (siteDoc.enableExpanolBtn) {
                      toggleLng.style.display = "block";
                    } else {
                      toggleLng.style.display = "none";
                    }
                  }

                  // Title font size desktop
                  let titleFontSizeDesktop = "28px";
                  if (siteDoc.titleSize) {
                    titleFontSizeDesktop = siteDoc.titleSize;
                  }

                  // Title font size Mobile
                  let titleFontSizeMobile = "28px";
                  if (siteDoc.titleSizeM) {
                    titleFontSizeMobile = siteDoc.titleSizeM;
                  }

                  // Title font Type
                  let titleFontTypeDesktop = "sans-serif";
                  if (siteDoc.titleType) {
                    titleFontTypeDesktop = siteDoc.titleType;
                  }
                  mainContainer2.style.fontFamily = titleFontTypeDesktop;

                  // Title Text English
                  let titleText = "Just In vehicle alerts at ";
                  if (siteDoc.titleText) {
                    titleText = siteDoc.titleText;
                    this.setState({ titleText });

                    strings.eng.signUpWelcome = titleText;
                    // this.setState({ languageStrings : strings.eng });
                  }

                  // Title Text Spanish
                  let titleTextSpanish = "Regístrese para recibir alertas de texto de Fresh Stock en ";
                  if (siteDoc.titleTextSpanish) {
                    titleTextSpanish = siteDoc.titleTextSpanish;
                    this.setState({ titleTextSpanish });

                    strings.esp.signUpWelcome = titleTextSpanish;
                    // this.setState({ languageStrings : strings.esp });
                  }

                  // How it works Text English
                  let helpMenu = 'If you are returning to this page and want to check the vehicle picks you have already made, then enter your phone number it the bottom box below where it says “Returning to this page? Enter your mobile number to access Dashboard”.<br /><br />If you haven’t ever entered a vehicle pick, then you will need to pick a Make and Model you want to receive notifications for.  Year range is optional.<br /><br />Once you are finished entering the vehicle you want to receive notifications for, then enter a valid mobile number.<br /><br />You can access your Dashboard with the green Next button.  Your Dashboard is where you can edit, renew or delete vehicle picks. ';
                  if (siteDoc.helpMenu) {
                    helpMenu = siteDoc.helpMenu;
                    this.setState({ helpMenu });

                    strings.eng.howitworks = helpMenu;
                    // this.setState({ languageStrings : strings.eng });
                  }

                  // How it works Text Spanish
                  let helpMenus = 'Si regresa a esta página y desea verificar las selecciones de vehículos que ya realizó, ingrese su número de teléfono en el cuadro inferior donde dice “¿Regresando a esta página? Ingrese su número de teléfono móvil para acceder al Tablero ”.<br /><br />Si nunca ingresó una selección de vehículo, deberá elegir una Marca y Modelo para los que desea recibir notificaciones. El rango de años es opcional.<br /><br />Una vez que haya terminado de ingresar el vehículo para el que desea recibir notificaciones, ingrese un número de teléfono móvil válido.<br /><br />Puede acceder a su Panel de control con el botón verde Siguiente. Su Tablero es donde puede editar, renovar o eliminar selecciones de vehículos.';
                  if (siteDoc.helpMenus) {
                    helpMenus = siteDoc.helpMenus;
                    this.setState({ helpMenus });

                    strings.esp.howitworks = helpMenus;
                    // this.setState({ languageStrings : strings.eng });
                  }

                  // How it works Text English
                  let howitworksText = "How It Works";
                  if (siteDoc.howitworksText) {
                    howitworksText = siteDoc.howitworksText;
                    this.setState({ howitworksText });

                    strings.eng.howitworksText = howitworksText;
                    // this.setState({ languageStrings : strings.eng });
                  }

                  // How it works Text Spanish
                  let howitworksTexts = "Cómo Funciona";
                  if (siteDoc.howitworksTexts) {
                    howitworksTexts = siteDoc.howitworksTexts;
                    this.setState({ howitworksTexts });

                    strings.esp.howitworksText = howitworksTexts;
                    // this.setState({ languageStrings : strings.eng });
                  }

                  // How it works Images
                  if (siteDoc.howitworksImg) {
                    const howitworksImg = siteDoc.howitworksImg;
                    this.setState({ howitworksImg });
                  }else{
                    this.setState({ howitworksImg : '' });
                  }


                  // How it works font color and background color
                  // const howitworksBtn = document.querySelector<HTMLElement>("#howitworks")!;

                  // let howitworksBgColor = "#0D47F0";
                  // if (siteDoc.howitworksBgColor) {
                  //   howitworksBgColor = siteDoc.howitworksBgColor;
                  // }

                  // howitworksBtn.style.background = howitworksBgColor;

                  // let howitworksColor = "#fff";
                  // if (siteDoc.howitworksColor) {
                  //   howitworksColor = siteDoc.howitworksColor;
                  // }

                  // howitworksBtn.style.color = howitworksColor;

                  // Home Button Text English
                  let homeButtonText = "Home";
                  if (siteDoc.homeButtonText) {
                    homeButtonText = siteDoc.homeButtonText;
                    this.setState({ homeButtonText });

                    strings.eng.homebtn = homeButtonText;
                    // this.setState({ languageStrings : strings.eng });
                  }

                  // Home Button Text Spanish
                  let homeButtonTextSpanish = "Hogar";
                  if (siteDoc.homeButtonTextSpanish) {
                    homeButtonTextSpanish = siteDoc.homeButtonTextSpanish;
                    this.setState({ homeButtonTextSpanish });

                    strings.esp.homebtn = homeButtonTextSpanish;
                    // this.setState({ languageStrings : strings.eng });
                  }

                  // Home button font color and background color
                  const homeBtnofBlock = document.querySelector<HTMLElement>("#just_in_home_btn")!;

                  let homeButtonBgColor = "#0D47F0";
                  if (siteDoc.homeButtonBgColor) {
                    homeButtonBgColor = siteDoc.homeButtonBgColor;
                  }

                  homeBtnofBlock.style.background = homeButtonBgColor;

                  let homeButtonColor = "#fff";
                  if (siteDoc.homeButtonColor) {
                    homeButtonColor = siteDoc.homeButtonColor;
                  }

                  homeBtnofBlock.style.color = homeButtonColor;

                  // Terms and condition Text English
                  let tncText =
                    "By selecting Next, you are signing up to receive automated text alerts and marketing calls from an autodialer system or live person. Consent to receive automated text alerts not required for purchase. Upon completion of this form, you will receive a text message with instructions to confirm your opt-in. Approx 31 msg/mo & Data Rates May Apply. Reply HELP for HELP, STOP ALL to cancel.";
                  if (siteDoc.tncText) {
                    tncText = siteDoc.tncText;
                    this.setState({ tncText });

                    strings.eng.disclaimer = tncText;
                    // this.setState({ languageStrings : strings.eng });
                  }

                  // Terms and Condition Text Spanish
                  let tncTextSpanish =
                    "Al seleccionar Siguiente, se registra para recibir alertas de texto automatizadas y llamadas de marketing de un sistema de marcación automática o una persona en vivo. No se requiere consentimiento para recibir alertas de texto automáticas para la compra. Al completar este formulario, recibirá un mensaje de texto con instrucciones para confirmar su suscripción. Se pueden aplicar hasta 31 msg / mes y tarifas de datos. Responda HELP para HELP, STOP ALL para cancelar.";
                  if (siteDoc.tncTextSpanish) {
                    tncTextSpanish = siteDoc.tncTextSpanish;
                    this.setState({ tncTextSpanish });

                    strings.esp.disclaimer = tncTextSpanish;
                    // this.setState({ languageStrings : strings.esp });
                  }

                  // Description Text English first line
                  let descText = "Get Alerts for newly-added vehicles, ";
                  if (siteDoc.descText) {
                    descText = siteDoc.descText;
                    this.setState({ descText });

                    strings.eng.getAlertsPromo = descText;
                    // this.setState({ languageStrings : strings.eng });
                  }

                  // Description Text English Second line
                  let descTextSecondline = "Straight to your phone! We'll send you a text when it arrives.";
                  if (siteDoc.descTextSecondline) {
                    descTextSecondline = siteDoc.descTextSecondline;
                    this.setState({ descTextSecondline });

                    strings.eng.getAlertsPromoSecondLine = descTextSecondline;
                    // this.setState({ languageStrings : strings.eng });
                  }

                  // Description Text Spanish first line
                  let descTextSpanish = "Obtenga alertas para vehículos recién agregados";
                  if (siteDoc.descTextSpanish) {
                    descTextSpanish = siteDoc.descTextSpanish;
                    this.setState({ descTextSpanish });

                    strings.esp.getAlertsPromo = descTextSpanish;
                    // this.setState({ languageStrings : strings.esp });
                  }

                  // Description Text English Second line
                  let descTextSpanishSecondline =
                    "Directo a su teléfono! Le enviaremos un mensaje de texto cuando llegue";
                  if (siteDoc.descTextSpanishSecondline) {
                    descTextSpanishSecondline = siteDoc.descTextSpanishSecondline;
                    this.setState({ descTextSpanishSecondline });

                    strings.esp.getAlertsPromoSecondLine = descTextSpanishSecondline;
                    // this.setState({ languageStrings : strings.esp });
                  }

                  // Description font size desktop
                  const descClass = document.querySelector<HTMLElement>(".centerDiv .signup_desc")!;

                  let descFontSizeDesktop = "19px";
                  if (siteDoc.descSize) {
                    descFontSizeDesktop = siteDoc.descSize;
                  }

                  let descFontSizeMobile = "19px";
                  if (siteDoc.descSizeM) {
                    descFontSizeMobile = siteDoc.descSizeM;
                  }

                  // Description font Type
                  let descFontTypeDesktop = "sans-serif";
                  if (siteDoc.descType) {
                    descFontTypeDesktop = siteDoc.descType;
                  }
                  descClass.style.fontFamily = descFontTypeDesktop;

                  // Terms and Conditions
                  const tncBlock = document.querySelector<HTMLElement>(".main-container .tnc_sign_up_block")!;

                  let tncFontSizeDesktop = "19px";
                  if (siteDoc.tncSize) {
                    tncFontSizeDesktop = siteDoc.tncSize;
                  }

                  let tncFontSizeMobile = "19px";
                  if (siteDoc.tncSizeM) {
                    tncFontSizeMobile = siteDoc.tncSizeM;
                  }

                  // Description font Type
                  let tncFontTypeDesktop = "sans-serif";
                  if (siteDoc.tncType) {
                    tncFontTypeDesktop = siteDoc.tncType;
                  }
                  tncBlock.style.fontFamily = tncFontTypeDesktop;

                  // Returning to this page? customization
                  const enterMobileReturnString = document.querySelector<HTMLElement>(
                    ".main-container #enter_mobile_return_string"
                  )!;

                  let retToPageSize = "28px";
                  if (siteDoc.retToPageSize) {
                    retToPageSize = siteDoc.retToPageSize;
                  }

                  let retToPageSizeM = "28px";
                  if (siteDoc.retToPageSizeM) {
                    retToPageSizeM = siteDoc.retToPageSizeM;
                  }

                  // font Type
                  let retToPageType = "sans-serif";
                  if (siteDoc.retToPageType) {
                    retToPageType = siteDoc.retToPageType;
                  }
                  enterMobileReturnString.style.fontFamily = retToPageType;
                  let retToPageText = "Returning to this page?";
                  if (siteDoc.retToPageText) {
                    retToPageText = siteDoc.retToPageText;
                    this.setState({ retToPageText });

                    strings.eng.enterMobileReturnString = retToPageText;
                    // this.setState({ languageStrings : strings.eng });
                  }

                  let retToPageTextSpanish = "Ingrese su número de teléfono móvil";
                  if (siteDoc.retToPageTextSpanish) {
                    retToPageTextSpanish = siteDoc.retToPageTextSpanish;
                    this.setState({ retToPageTextSpanish });

                    strings.esp.enterMobileReturnString = retToPageTextSpanish;
                    // this.setState({ languageStrings : strings.eng });
                  }

                  // Enter your mobile number to access dashboard customization
                  const enterMobileDashboard = document.querySelector<HTMLElement>(
                    ".main-container #enterMobileDashboard"
                  )!;

                  let enableItalic = true;
                  enableItalic = siteDoc.enableItalic;
                  if (enableItalic) {
                    enterMobileDashboard.style.fontStyle = "italic";
                  } else {
                    enterMobileDashboard.style.fontStyle = "normal";
                  }

                  let accessDashboardSize = "21px";
                  if (siteDoc.accessDashboardSize) {
                    accessDashboardSize = siteDoc.accessDashboardSize;
                  }

                  let accessDashboardSizeM = "21px";
                  if (siteDoc.retToPageSizeM) {
                    accessDashboardSizeM = siteDoc.accessDashboardSizeM;
                  }

                  // font Type
                  let accessDashboardType = "sans-serif";
                  if (siteDoc.accessDashboardType) {
                    accessDashboardType = siteDoc.accessDashboardType;
                  }
                  enterMobileDashboard.style.fontFamily = accessDashboardType;
                  let accessDashboardText = "Enter your mobile number to access Dashboard";
                  if (siteDoc.accessDashboardText) {
                    accessDashboardText = siteDoc.accessDashboardText;
                    this.setState({ accessDashboardText });

                    strings.eng.enterMobileDashboard = accessDashboardText;
                    // this.setState({ languageStrings : strings.eng });
                  }

                  let accessDashboardTextSpanish = "Ingrese su número de teléfono móvil";
                  if (siteDoc.accessDashboardTextSpanish) {
                    accessDashboardTextSpanish = siteDoc.accessDashboardTextSpanish;
                    this.setState({ accessDashboardTextSpanish });

                    strings.esp.enterMobileDashboard = accessDashboardTextSpanish;
                    // this.setState({ languageStrings : strings.eng });
                  }

                  // Logo width and height
                  const sighnupLogo = document.querySelector<HTMLElement>(".main-container .logo")!;

                  let widthForDesktop = "280px";
                  let widthForMobile = "280px";
                  let heightForDesktop = "130px";
                  let heightForMobile = "130px";

                  if (siteDoc.widthForDesktop) {
                    widthForDesktop = siteDoc.widthForDesktop;
                  }
                  if (siteDoc.widthForMobile) {
                    widthForMobile = siteDoc.widthForMobile;
                  }
                  if (siteDoc.heightForDesktop) {
                    heightForDesktop = siteDoc.heightForDesktop;
                  }
                  if (siteDoc.heightForMobile) {
                    heightForMobile = siteDoc.heightForMobile;
                  }

                  // Home button block
                  const homeBtnBlock = document.querySelector<HTMLElement>(".centerDiv #just_in_home_btn")!;
                  homeBtnBlock.style.display = "none";
                  if (siteDoc.homeBtnEnable) {
                    homeBtnBlock.style.display = "block";
                  }

                  if (siteDoc.homeBtnUrl) {
                    this.setState({
                      homePageUrl: siteDoc.homeBtnUrl,
                    });
                  }

                  if (siteDoc.enableVipClub) {
                    this.setState({
                      enableVipClub: siteDoc.enableVipClub,
                    });
                  }

                  if (siteDoc.englishKeyword) {
                    this.setState({
                      englishKeyword: siteDoc.englishKeyword,
                    });
                  }

                  if (siteDoc.englishLocation) {
                    this.setState({
                      englishLocation: siteDoc.englishLocation,
                    });
                  }

                  let englishVipClubCheckboxText = "Want to join "+ snap.docs[0].data().businessName +" " + this.renderSiteName(siteDoc.path) + "'s VIP Club? Click here! ";

                  if (siteDoc.englishVipClubCheckboxText) {
                    englishVipClubCheckboxText = siteDoc.englishVipClubCheckboxText
                  }
                  this.setState({ englishVipClubCheckboxText });

                  let englishVipClubHoverText = snap.docs[0].data().businessName +" -REWARDS DONE RIGHT. "+ snap.docs[0].data().businessName +"'s VIP Members enjoy exclusive access to all things "+ snap.docs[0].data().businessName +". Members earn discounts on parts, free yard entries, "+ snap.docs[0].data().businessName +" merch, early yard access, and other automotive accessories - on us. Here at "+ snap.docs[0].data().businessName +", your parts are our priority! We understand your needs and work endlessly to make sure that we've got you covered. Joining our VIP Club is simple: sign up with your mobile number, enable text updates, and let the rewards come to you!";

                  if (siteDoc.englishVipClubHoverText) {
                    englishVipClubHoverText = siteDoc.englishVipClubHoverText
                  }
                  this.setState({ englishVipClubHoverText });

                  if (siteDoc.spanishKeyword) {
                    this.setState({
                      spanishKeyword: siteDoc.spanishKeyword,
                    });
                  }

                  if (siteDoc.spanishLocation) {
                    this.setState({
                      spanishLocation: siteDoc.spanishLocation,
                    });
                  }

                  let spanishVipClubCheckboxText = "¿Quiere unirse al club VIP de "+ snap.docs[0].data().businessName +" " + this.renderSiteName(siteDoc.path) + "? ¡Haga clic aquí!";

                  if (siteDoc.spanishVipClubCheckboxText) {
                    spanishVipClubCheckboxText = siteDoc.spanishVipClubCheckboxText;
                  }
                  this.setState({ spanishVipClubCheckboxText });

                  let spanishVipClubHoverText = snap.docs[0].data().businessName +" -REWARDS DONE RIGHT. "+ snap.docs[0].data().businessName +"'s VIP Members enjoy exclusive access to all things "+ snap.docs[0].data().businessName +". Members earn discounts on parts, free yard entries, "+ snap.docs[0].data().businessName +" merch, early yard access, and other automotive accessories - on us. Here at "+ snap.docs[0].data().businessName +", your parts are our priority! We understand your needs and work endlessly to make sure that we've got you covered. Joining our VIP Club is simple: sign up with your mobile number, enable text updates, and let the rewards come to you!";

                  if (siteDoc.spanishVipClubHoverText) {
                    spanishVipClubHoverText = siteDoc.spanishVipClubHoverText;
                  }
                  this.setState({ spanishVipClubHoverText });

                  // media query
                  if (mql.matches === true) {
                    mainContainer2.style.fontSize = titleFontSizeMobile;
                    descClass.style.fontSize = descFontSizeMobile;
                    tncBlock.style.fontSize = tncFontSizeMobile;
                    enterMobileReturnString.style.fontSize = retToPageSizeM;
                    enterMobileDashboard.style.fontSize = accessDashboardSizeM;

                    // logo style
                    sighnupLogo.style.width = widthForMobile;
                    sighnupLogo.style.height = heightForMobile;
                    sighnupLogo.style.maxWidth = "90%";
                    sighnupLogo.style.maxHeight = "90%";
                  } else {
                    mainContainer2.style.fontSize = titleFontSizeDesktop;
                    descClass.style.fontSize = descFontSizeDesktop;
                    tncBlock.style.fontSize = tncFontSizeDesktop;
                    enterMobileReturnString.style.fontSize = retToPageSize;
                    enterMobileDashboard.style.fontSize = accessDashboardSize;

                    // logo style
                    sighnupLogo.style.width = widthForDesktop;
                    sighnupLogo.style.height = heightForDesktop;
                    sighnupLogo.style.maxWidth = "90%";
                    sighnupLogo.style.maxHeight = "90%";
                  }

                  this.setState({ site: siteDoc, siteId: siteSnap.docs[0].id });
                  if (siteDoc.theme && siteDoc.theme.logo) {
                    this.setState({ logo: siteDoc.theme.logo });
                  }
                }
              });
          }
        });
    }
    if (params.mobile && params.business && params.site) {
      // if (params.business === "go-pull-it") {
      //   import("../styles/justingopullit.css");
      // }
      this.watchPicks(params.mobile, params.business, params.site);
      this.setState({ mobile: params.mobile });
    } else {
      this.setState({ mobile: null });
    }
  }

  public componentWillUnmount() {
    const matches = document.querySelector<HTMLElement>(".css-1k7bvv7")!;
    matches.style.backgroundColor = "#e5e5e5";
  }

  public render() {
    const {
      addingNewPick,
      businessDoc,
      businessId,
      isOpenHelp,
      picks,
      language,
      languageStrings,
      logo,
      // matches,
      matchesVehicle,
      mobile,
      site,
      siteId,
      tearApartVehicleOgden,
      tearApartVehicleSlc
    } = this.state;

    const { params } = this.props.match;
    const dialogProps: Dialog["props"] = {
      canEscapeKeyClose: true,
      canOutsideClickClose: true,
      isOpen: isOpenHelp,
      onClose: () => this.setState({ isOpenHelp: false }),
      title: languageStrings.helpTxt,
    };

  
    let matchesRows;
    if (matchesVehicle === null) {
      matchesRows = (
        <tr>
          <td>{languageStrings.selectAVehicle}</td>
        </tr>
      );
    } else if (matchesVehicle.length === 0) {
      matchesRows = (
        <tr>
          <td>{languageStrings.noFreshStock}</td>
        </tr>
      );
    } else {
      matchesRows = matchesVehicle.map((vehicle, index) => this.renderMatchRow(vehicle, index));
    }
    if (businessDoc === null) {
      return (
        <div style={{ height: "100%", width: "100%", paddingTop: "10px" }}>
          {params.match && params.match.business === "go-pull-it" ? (
            <link
              rel="stylesheet"
              type="text/css"
              href={"//gopullit.com/wp-content/themes/gopullit/assets/css/txtnrewards-overrides.css"}
            />
          ) : (
            ""
          )}
          <Spinner />
        </div>
      );
    }

    if (addingNewPick) {
      return (
        <>
          {businessDoc.path === "go-pull-it" ? (
            <link
              rel="stylesheet"
              type="text/css"
              href={"//gopullit.com/wp-content/themes/gopullit/assets/css/txtnrewards-overrides.css"}
            />
          ) : (
            ""
          )}
          <Notifications
            businessId={businessId}
            language={language}
            mobile={mobile}
            siteId={siteId}
            strings={languageStrings}
            toggleLanguage={this.toggleLanguage}
            welcomeFlow={false}
            displayBtn = {true}
            handleSelected={() => {
              this.setState({ addingNewPick: false });
              if (mobile) {
                this.watchPicks(mobile, this.props.match.params.business, this.props.match.params.site);
              }
            }}
          />
        </>
      );
    }

    if (mobile === null && businessDoc !== null) {
      return (
        <>
          {businessDoc.path === "go-pull-it" ? (
            <link
              rel="stylesheet"
              type="text/css"
              href={"//gopullit.com/wp-content/themes/gopullit/assets/css/txtnrewards-overrides.css"}
            />
          ) : (
            ""
          )}
          <div className="center main-container just-wrapper">
            <InputMobile
              business={businessDoc}
              language={language}
              logo={this.state.logo}
              handleMobileInput={this.handleMobileInput}
              howitworksImg={this.state.howitworksImg}
              homePageUrl={this.state.homePageUrl}
              englishVipClubCheckboxText={this.state.englishVipClubCheckboxText}
              englishVipClubHoverText={this.state.englishVipClubHoverText}
              spanishVipClubCheckboxText={this.state.spanishVipClubCheckboxText}
              spanishVipClubHoverText={this.state.spanishVipClubHoverText}
              enableVipClub={this.state.enableVipClub}
              toggleLanguage={this.toggleLanguage}
              site={site}
              siteId={siteId}
              strings={languageStrings}
            />
          </div>
        </>
      );
    }
    let justInBrandingWord = "Just In";
    if (businessDoc.justInBrandingWord) {
      justInBrandingWord = businessDoc.justInBrandingWord;
    }
    const matches1 = document.querySelector<HTMLElement>(".css-1k7bvv7")!;
    if(matches1 && (tearApartVehicleOgden || tearApartVehicleSlc ||(siteId && siteId === 'bsZLKWJMaoIwztWi0gMg' && businessId && businessId === 'WpJtEW5saD7d4bRutXXb') || (siteId && siteId === 'JGOUaPdjCw7AxY1auyYy' && businessId && businessId === 'SmhXMTflviq60mlf221Z'))){
      if(tearApartVehicleOgden || tearApartVehicleSlc ){
        matches1.style.background = 'linear-gradient(rgba(255,255,255,.9355), rgba(255,255,255,.9355)), url(' + logo + ') no-repeat center, url(' + require("../images/tearapartlogo.png") + ') center';
      }else{
        matches1.style.background = 'linear-gradient(rgba(255,255,255,.9355), rgba(255,255,255,.9355)), url(' + logo + ') no-repeat center';
      }
    }
    return (
      <div style={{ height: "100%", width: "100%", paddingTop: "10px", backgroundImage: "url(" + { logo } + ")" }}>
        {businessDoc.path === "go-pull-it" ? (
          <link
            rel="stylesheet"
            type="text/css"
            href={"//gopullit.com/wp-content/themes/gopullit/assets/css/txtnrewards-overrides.css"}
          />
        ) : (
          ""
        )}
        <VehicleModal
          show={this.state.showVehicleModal}
          strings={languageStrings}
          handleClose={() => this.setState({ showVehicleModal: false })}
          vehicle={this.state.vehicle}
          vehicleUrl={businessDoc.vehicleUrl}
        />
        <span
          style={{
            display: "inline-block",
            paddingLeft: "10px",
            paddingTop: "10px",
            position: "absolute",
            textAlign: "center",
            top: "0",
          }}
        >
          <H1
            style={{
              color: "#0968aa",
              display: "inline",
              fontWeight: "bold",
              margin: "0 auto",
              verticalAlign: "bottom",
            }}
          >
            {justInBrandingWord} {logo === null ? "" : "At"}
          </H1>{" "}
          &nbsp;&nbsp;

          {tearApartVehicleSlc || tearApartVehicleOgden || (siteId && siteId === 'bsZLKWJMaoIwztWi0gMg' && businessId && businessId === 'WpJtEW5saD7d4bRutXXb') || (siteId && siteId === 'JGOUaPdjCw7AxY1auyYy' && businessId && businessId === 'SmhXMTflviq60mlf221Z') ?
          (logo === null ? "" : <img src={logo} height={60} width={198} />):(logo === null ? "" : <img src={logo} height={43} width={73} />)}
          &nbsp;&nbsp;
        </span>
        <br />
        <div>
          <Button
            style={{ verticalAlign: "bottom" }}
            icon={"add"}
            large={false}
            intent={"success"}
            onClick={() => this.setState({ addingNewPick: true })}
            name="add new"
          >
            {languageStrings.addNewPick}
          </Button>{" "}
          &nbsp; &nbsp;
          <Button intent="success" onClick={(e) => this.toggleLanguage()}>
            {languageStrings.toggleLanguage}
          </Button>
          &nbsp; &nbsp;
          <Button
            style={{ verticalAlign: "bottom" }}
            intent={"primary"}
            onClick={() => this.setState({ isOpenHelp: true })}
          >
            {languageStrings.helpTxt}
          </Button>
        </div>

        <Dialog {...dialogProps}>
          <div className={Classes.DIALOG_BODY}>
            <p dangerouslySetInnerHTML={{ __html: languageStrings.helpTxtDesc }} />
          </div>
        </Dialog>

        <div style={{ paddingLeft: "10px" }}>&nbsp;</div>
        <div
          style={{
            alignItems: "center",
            display: "inline-block",
            justifyContent: "center",
            margin: "0 auto",
            width: "60%",
          }}
        >
          <HTMLTable>
            <thead>
              <tr>
                <th />
                <th>{languageStrings.myPicks}</th>
                <th>{languageStrings.new}</th>
              </tr>
            </thead>
            <tbody>
              {picks.length === 0
                ? this.welcomeInstructions
                : picks.map((pick, index) => this.renderPickRow(pick, index))}
            </tbody>
          </HTMLTable>
        </div>
        <div
          style={{
            alignItems: "center",
            display: "inline-block",
            float: "right",
            justifyContent: "center",
            margin: "0 auto",
            // position: "fixed",
            width: "40%",
          }}
        >
          <HTMLTable striped={true}>
            <thead>
              <tr>
                <th>{languageStrings.newVehicles}</th>
              </tr>
            </thead>
            <tbody>{matchesRows}</tbody>
          </HTMLTable>
        </div>
      </div>
    );
  }

  private renderSiteName = (path: any) => {
    if (path.includes("-")) {
      let words = path.split("-");
      words = words.filter((e) => e !== "vehicles"); // remove 'vehicles' word from the site name

      const uppercase = words.map((str) => {
        return str.charAt(0).toUpperCase() + str.substring(1);
      });
      return uppercase.join(" ");
    }
    return path.charAt(0).toUpperCase() + path.substring(1);
  };

  private handleMobileInput = async(mobile: string, isVipClub: boolean, isVipClubS: boolean) => {
    // validate number
    const params = this.props.match.params;
    this.watchPicks(mobile, params.business, params.site);


    const { tearApartVehicleSlc, tearApartVehicleOgden } = this.state;

    const businessQuery1 = await firestore
    .collection("businesses")
    .where("path", "==", params.business)
    .get();
    let businessDoc;
    if (!businessQuery1.empty) {
      businessDoc = businessQuery1.docs[0].data();
      const slc = this.state.siteId && this.state.siteId === 'bsZLKWJMaoIwztWi0gMg' && businessDoc.businessId && businessDoc.businessId === 'WpJtEW5saD7d4bRutXXb' ? true:false;
      const ogden = this.state.siteId && this.state.siteId === 'JGOUaPdjCw7AxY1auyYy' && businessDoc.businessId && businessDoc.businessId === 'SmhXMTflviq60mlf221Z' ? true:false;
      if(tearApartVehicleSlc || tearApartVehicleOgden || slc || ogden){
        const { language } = this.state;
        let keyword = '';
        let vipClub = false;
        let location = '';
        if(language === 'eng'){
          vipClub = isVipClub;
          keyword = this.state.englishKeyword;
          if(slc || tearApartVehicleSlc){
            // keyword = 'tearapartslc';
            location = this.state.englishLocation; 
          }
          if(ogden || tearApartVehicleOgden){
            location = this.state.englishLocation;
            // keyword = 'tearapart';
          }
        }else{
          vipClub = isVipClubS;
          keyword = this.state.spanishKeyword;
          location = '';
          if(slc || tearApartVehicleSlc){
            location = this.state.englishLocation;
            // keyword = 'tearapartslcespanol';
          }
          if(ogden || tearApartVehicleOgden){
            location = this.state.englishLocation;
            // keyword = 'tearapartespanol';
          }
        }
  
        if(vipClub){
          fetch(
            "https://client.texnrewards.net/gateway/contactmanager_keyword.asp",
            {
              body:JSON.stringify({
                keyword,
                location,
                mobile,
                redirectURL:this.state.homePageUrl,
                shortcode:businessDoc.shortcode,
                user_guid:businessDoc.guid,
              }),
              method:'POST',
              mode: 'cors',
  
            }
          )
          .catch((error) => {
            console.error(error);
          });
        }
      }else{
        const { language } = this.state;
        let keyword = '';
        let vipClub = false;
        const location = this.state.englishLocation;

        if(language === 'eng'){
          vipClub = isVipClub;
          keyword = this.state.englishKeyword;
        }else{
          vipClub = isVipClubS;
          keyword = this.state.spanishKeyword;
        }

        if(vipClub){
          fetch(
            "https://client.texnrewards.net/gateway/contactmanager_keyword.asp",
            {
              body:JSON.stringify({
                keyword,
                location,
                mobile,
                redirectURL:this.state.homePageUrl,
                shortcode:businessDoc.shortcode,
                user_guid:businessDoc.guid,
              }),
              method:'POST',
              mode: 'cors',
  
            }
          )
          .catch((error) => {
            console.error(error);
          });
        }

      }

    }
    this.setState({ mobile });
  };
  private renderPickRow = (pick: VehiclePick, index: number) => {
    let fetchingInfo: boolean = false;
    let isFresh: boolean = false;
    let isFreshIcon;
    if (pick.matches === null) {
      fetchingInfo = true;
      isFresh = false;
      isFreshIcon = <Icon className="icon-spin" icon="refresh" iconSize={20} />;
    } else if (pick.matches.length === 0) {
      isFresh = false;
      isFreshIcon = <Icon icon="unknown-vehicle" iconSize={25} intent={Intent.DANGER} />;
    } else {
      isFresh = true;
      isFreshIcon = <Icon icon="known-vehicle" iconSize={25} intent={Intent.SUCCESS} />;
    }

    const remainDays =
      this.state.businessDoc.showPickLeft !== false ? (
        <span style={{ fontSize: "10px" }}>{pick[`remainDays`]}d left</span>
      ) : (
        ""
      );

    const deletePick = (
      <Icon onClick={() => this.deletePick(pick, index)} icon="delete" iconSize={20} intent={Intent.DANGER} />
    );

    const renewPick = (
      <Icon onClick={() => this.renewPick(pick, index)} icon="automatic-updates" iconSize={20} intent={Intent.SUCCESS} />
    );

    const text = pick.yearMin + "-" + pick.yearMax + " " + pick.combined;
    if (this.state.rowSelected === index) {
      console.log("state: " + this.state.rowSelected + " index: " + index);
    }

    return (
      <tr className={this.state.rowSelected === index ? "bordered" : ""} style={hoverRow} key={index}>
        <td>{deletePick}</td>
        <td onClick={() => this.handlePickSelected(pick, index)}>{text}</td>
        <td>
          {isFreshIcon} <br /> {remainDays} <br /> {this.isNewText(fetchingInfo, isFresh)}
        </td>
        <td>{renewPick}</td>
      </tr>
    );
  };

  private isNewText = (fetchingInfo: boolean, isFresh: boolean) => {
    if (fetchingInfo) {
      return "";
    }

    if (isFresh) {
      return <p style={{ fontSize: "9px" }}>New Vehicle</p>;
    } else {
      return <p style={{ fontSize: "9px" }}>No New Vehicle</p>;
    }
  };

  private deletePick = async (pick: VehiclePick, index: number) => {
    const { picks } = this.state;

    const docQuery = await firestore
      .collection("vehiclePicks")
      .doc(pick.docId)
      .get();

    if (docQuery.exists) {
      docQuery.ref.delete();
    }

    picks.splice(index, 1);
    this.setState({ picks });
  };

  private renewPick = async (pick: VehiclePick, index: number) => {
    const { picks } = this.state;

    const docQuery = await firestore
      .collection("vehiclePicks")
      .doc(pick.docId)
      .get();

    if (docQuery.exists) {

      const newTime = new Date().getTime();
      const newTimestamp : Timestamp = TimestampFunc.fromMillis(newTime);

      const pick2 = docQuery.ref;
      pick2.update({
        timestamp:newTimestamp
      }).then(()=> {
        picks[index].timestamp = newTimestamp;
        picks[index].remainDays = 90;
        this.setState({ picks });
      });
    }

  };

  private renderMatchRow = (vehicle: any, index: number) => {
    console.log("showing match row...");
    console.log(vehicle);
    const yardDate = new Date(vehicle.YARD_DATE);
    const today = new Date();
    const diff = differenceInDays(today, yardDate);
    const smartmatch = (vehicle.smartMatch !== undefined && vehicle.smartMatch === true)?" ( Smart Match )":"";
    const text =
      vehicle.HOL_YEAR +
      " " +
      vehicle.MAKE[0] +
      " " +
      vehicle.MODEL[0] +
      " @ " +
      vehicle.YARD_NAME +
      " - " +
      diff +
      "d ago"+
      smartmatch;
    return (
      <tr key={index} onClick={() => this.setState({ vehicle, showVehicleModal: true })}>
        <td style={hoverRow}>{text}</td>
      </tr>
    );
  };

  private handlePickSelected = async (pick: VehiclePick, index: number) => {
    console.log("finding " + pick.combined);
    console.log(pick);
    const { matchesNewVehicle } = this.state;
    this.setState({ matches: pick.matches, rowSelected: index, matchesVehicle: matchesNewVehicle[index] });
    console.log(this.state);
  };

  private findPickMatches = async (pick: VehiclePick, index: number) => {
    if (pick === undefined) {
      return;
    }
    const result = await getMatchesForVehicle(pick);
    // console.log(result);
    let matches = result.data;
    if (matches === null) {
      matches = [];
    }

    const newPick = pick;
    const originalModel = pick.model;
    let newMatches:any = [];
    const filtModel = modelList.filter((e) => e.make === pick.make && e.replaceby === pick.model);

    if(filtModel.length){
      for(const val of filtModel){
        newPick.model = val.model;
        const res = await getMatchesForVehicle(newPick);
        if(res.data !== null && res.data[0] !== undefined){
          if(originalModel !== newPick.model){
            res.data[0].smartMatch = true;
          }
          newMatches.push(res.data[0]);
        }

      }
      matches = newMatches;
    }else{
      newMatches = matches;
    }

    this.state.matchesNewVehicle[index] = newMatches;

    this.state.picks[index].matches = matches;
    this.forceUpdate();
  };

  private watchPicks = async (mobile: string, business: string, site: string) => {
    let query;
    if (business) {
      const businessQuery = await firestore
        .collection("businesses")
        .where("path", "==", business)
        .get();
      let businessDoc;
      if (!businessQuery.empty) {
        businessDoc = businessQuery.docs[0].data();
        // console.log(businessDoc);
        if (businessDoc.theme && businessDoc.theme.logo) {
          this.setState({ logo: businessDoc.theme.logo });
        }
        if (businessDoc.s3Id || businessDoc.urgId || !site || site === "-") {
          query = await firestore
            .collection("vehiclePicks")
            .where("mobile", "==", mobile)
            .where("businessId", "==", businessDoc.businessId)
            .get();
        } else if (site && site !== "-") {
          const siteQuery = await businessQuery.docs[0].ref
            .collection("sites")
            .where("path", "==", site)
            .get();
          const siteDoc = await siteQuery.docs[0].data();
          const siteId = siteQuery.docs[0].id;
          if (siteDoc.theme && siteDoc.theme.logo) {
            this.setState({ logo: siteDoc.theme.logo });
          }
          if (siteDoc.s3Id || siteDoc.urgId) {
            query = await firestore
              .collection("vehiclePicks")
              .where("mobile", "==", mobile)
              .where("siteId", "==", siteId)
              .get();
          } else {
            query = await firestore
              .collection("vehiclePicks")
              .where("mobile", "==", mobile)
              .get();
          }
        } else {
          query = await firestore
            .collection("vehiclePicks")
            .where("mobile", "==", mobile)
            .get();
        }
      }
    } else {
      query = await firestore
        .collection("vehiclePicks")
        .where("mobile", "==", mobile)
        .get();
    }

    const picks: any[] = [];
    query.forEach((doc) => {
      const pick = doc.data() as VehiclePick;
      pick.docId = doc.ref.id;
      pick.matches = null;

      if (pick.timestamp) {
        const timestampToDate = pick.timestamp.toDate();
        const diff = new Date().getTime() - new Date(timestampToDate).getTime();
        const delta = diff / 1000;
        const days = Math.floor(delta / 86400);

        const remainDays = 90 - (days > 90 ? 90 : days);
        pick.remainDays = remainDays;
      }


      if(pick && pick.timestamp === undefined){
        pick.remainDays = 90;
      }

      if (pick.make === "CHEVROLET" && pick.model.includes("SUBURBAN")) {
        // SAAB models needs to add dash after the first letter, if it doesnt exist
        pick.combined =  "CHEVROLET SUBURBAN";
      }
      picks.push(pick);

      counter += 1;
    });
    this.setState({ picks });
    let counter = 0;
    this.state.picks.forEach(async (pick) => {
      this.findPickMatches(pick, counter);
      counter += 1;
    });
    console.log("STATE:");
    console.log(this.state);
  };
}
export default JustInPage;



// WEBPACK FOOTER //
// ./src/views/JustIn.tsx